module.exports = __webpack_public_path__ + "static/img/zz_hf.fa050ad1.png";